import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  QueryConstraint,
  QueryDocumentSnapshot,
  type DocumentSnapshot,
} from "firebase/firestore/lite";
import { dbLite } from "../services/Firebase.js";

/**
 * One-shot REST reads. The full Firestore SDK multiplexes getDocs on a Listen
 * stream that can sit dead ~20s then recover (~22s). App loads must not wait
 * on that stream. Writes and realtime listeners stay on the full SDK.
 */
export async function getLiteQueryDocs(
  collectionName: string,
  constraints: QueryConstraint[] = []
): Promise<QueryDocumentSnapshot[]> {
  const snapshot = await getDocs(
    constraints.length > 0
      ? query(collection(dbLite, collectionName), ...constraints)
      : query(collection(dbLite, collectionName))
  );
  return snapshot.docs;
}

export async function getLiteQueryDocsAt(
  path: [string, ...string[]],
  constraints: QueryConstraint[] = []
): Promise<QueryDocumentSnapshot[]> {
  const snapshot = await getDocs(
    constraints.length > 0
      ? query(collection(dbLite, ...path), ...constraints)
      : query(collection(dbLite, ...path))
  );
  return snapshot.docs;
}

export async function getLiteDoc(
  collectionName: string,
  id: string
): Promise<DocumentSnapshot> {
  return getDoc(doc(dbLite, collectionName, id));
}
